import React, { Component, Fragment } from 'react';
import DispatchProps from '../../../utils/DispatchProps';
import { connect } from "react-redux";
import { IRootState } from '../../../store';
import LinkCard from '../../LinkCard';
import SchoolPageTitle from '../../SchoolPageTitle';
import AdminSchoolMenu from '../../AdminSchoolMenu';

interface SchoolToolsMenuPageProps {
    tenantId: string;
    schoolCode: string;
}

interface SchoolToolsMenuPageState {
}

class SchoolToolsMenuPage extends Component<SchoolToolsMenuPageProps & DispatchProps, SchoolToolsMenuPageState> {

    constructor(props: SchoolToolsMenuPageProps & DispatchProps) {
        super(props)
        this.state = {
        }
    }

    async componentDidMount() {

    }

    async componentDidUpdate(prevProps: Readonly<SchoolToolsMenuPageProps & DispatchProps>, prevState: Readonly<SchoolToolsMenuPageState>, snapshot?: any): Promise<void> {

    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Tools" />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />

                <div className={"flex-row"}>
                    <LinkCard to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/create-sites`}
                              iconName="SharepointAppIcon16"
                              title="Bulk Create Sites"
                              description={"Bulk create SharePoint sites"}
                    />

                    <LinkCard to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/analyse-data`}
                              iconName="ReportDocument"
                              title="Analyse Data"
                              description={"View data synced from SDS"}
                    />

                    <LinkCard to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/archive-tool`}
                              iconName="Archive"
                              title="Archive Tool"
                              description={"Archive classes between dates"}
                    />
                </div>
                
                <div className={"flex-row"}>
                    <LinkCard to={`/cdb-admin/schools/${this.props.tenantId}/${this.props.schoolCode}/customer-tools-menu`}
                              iconName="DeveloperTools"
                              title="Customer Tools"
                              description={"View customer tools"}
                    />
                </div>
                    
            </Fragment>
        )
    }
}

export default connect(
    (state: IRootState, ownProps: { match: any }): SchoolToolsMenuPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
        };
    }
)(SchoolToolsMenuPage)